import { render, staticRenderFns } from "./PcrTemplateView.vue?vue&type=template&id=3d3b4cfe&scoped=true"
import script from "./PcrTemplateView.vue?vue&type=script&lang=ts"
export * from "./PcrTemplateView.vue?vue&type=script&lang=ts"
import style0 from "./PcrTemplateView.vue?vue&type=style&index=0&id=3d3b4cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3b4cfe",
  null
  
)

export default component.exports